<template>
    <span class="text-warning float-left mr-1">
        <i
            class="fa fa-arrow-down fa-lg icon-button"
            title="Aplicar Deflator na Fase"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            :id="modalId"
            v-model="mostrarModal"
            @shown="aoAbrirModal"
            @hidden="reset()"
        >
            <div slot="modal-title">
                Deflator da Fase -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>

            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>

            <b-row class="mb-2">
                <b-col sm="12">
                    <small class="text-muted">
                        <b>Fase:</b>
                        {{ fase.descricao }}
                    </small>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valorDeflator.$dirty ? !$v.valorDeflator.$invalid : null"
                        invalid-feedback="Informe um valor válido maior que zero."
                    >
                        <label class="required">Valor do Deflator</label>

                        <money
                            :key="moneyKey"
                            v-model="valorDeflator"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valorDeflator.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-1"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvar()"
                >
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ContratosServicos from '../ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },
        fase: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'ATUALIZAÇÃO',
            erros: [],
            valorDeflator: 0,
            moneyKey: 0,

            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    computed: {
        modalId() {
            return `modalDeflatorFaseContrato_${this.fase.faseContratoId}`
        },

        desabilitarBtnSalvar() {
            return this.$v.$dirty && this.$v.$invalid
        },
    },

    watch: {
        'fase.faseContratoId': function () {
            if (this.mostrarModal) {
            this.preencherForm()
            this.moneyKey++
            }
        },
        'fase.consumoContratoAnterior': function () {
            if (this.mostrarModal) {
            this.preencherForm()
            this.moneyKey++
            }
        }
    },

    methods: {
        abrirModal() {
        this.reset()
        this.mostrarModal = true
        },

        aoAbrirModal() {
            this.preencherForm()
            this.moneyKey++

            this.$nextTick(() => {
            if (this.$v && this.$v.valorDeflator) {
                this.$v.valorDeflator.$touch()
            }
            })
        },

        fecharModal() {
            this.mostrarModal = false
        },

        reset() {
            this.erros = []
            this.valorDeflator = 0

            if (this.$v) {
                this.$nextTick(() => this.$v.$reset())
            }
        },

        preencherForm() {
            const atual = this.fase && this.fase.consumoContratoAnterior != null
            ? Number(this.fase.consumoContratoAnterior)
            : 0

            this.valorDeflator = Math.abs(atual) || 0
        },

        confirmarSalvar() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            this.$swal({
                title: 'Deflator da Fase',
                html: `Confirma salvar o deflator da fase <b>${this.fase.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')

            const valorPositivo = Number(this.valorDeflator) || 0
            const dto = { valorDeflator: valorPositivo }

            ContratosServicos.aplicarDeflatorFaseContrato(
                this.contrato.idContrato,
                this.fase.faseContratoId,
                dto
            )
            .then((response) => {
                if (!response) return

                if (response.success) {
                    this.$toast.success(
                        'Deflator aplicado na Fase com sucesso.',
                        'OK',
                        this.$toastConfig.success)

                    this.$emit('obterContratoAtualizado', true)
                    this.mostrarModal = false
                } else {
                    this.erros = response.errors
                }
            })
            .finally(() => {
                this.$store.dispatch('removeRequest')
            })
        }
    },

    validations: {
        valorDeflator: {
            required,
            minValue: minValue(0.01)
        }
    }
}
</script>
